import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded } from '../../../../layout/redux/layoutActions'

export const HISTORY_PAGE_SIZE = 20

export const HISTORY_FETCH_REQUEST = 'HISTORY_FETCH_REQUEST'
export const HISTORY_FETCH_SUCCESS = 'HISTORY_FETCH_SUCCESS'
export const HISTORY_FETCH_FAILURE = 'HISTORY_FETCH_FAILURE'
export const HISTORY_SET_MOTIVO_FILTER = 'HISTORY_SET_MOTIVO_FILTER'

const normalizarTexto = valor => {
  if (valor === null || valor === undefined) return null
  return String(valor).trim()
}

const normalizarPlanos = itens => {
  if (!Array.isArray(itens)) {
    return []
  }

  return itens.map(item => ({
    id: item.pdca_plano_id,
    pdcaPlanoId: item.pdca_plano_id,
    numeroPlano: item.numero_plano,
    titulo: item.titulo_plano,
    tipoPlano: normalizarTexto(item.tipo_plano),
    ciclo: 'history',
    catoutop: normalizarTexto(item.catoutop),
    categoriaNome: item.categoria_nome,
    topicoNome: item.topico_nome,
    empresaId: item.empresa_id,
    lojaNome: item.loja_nome,
    produtoNome: item.produto_nome,
    nomeescopo: item.nomeescopo,
    dataFinal: item.data_final,
    motivoconcluido: normalizarTexto(item.motivoconcluido),
    npsAntes: normalizarTexto(item.nps_antes),
    npsDepois: normalizarTexto(item.nps_depois),
    deltaNps: normalizarTexto(item.delta_nps),
    melhoriaPercentualTotal: normalizarTexto(item.melhoria_percentual_total)
  }))
}

export const setHistoryMotivoFilter = motivoconcluido => ({
  type: HISTORY_SET_MOTIVO_FILTER,
  payload: motivoconcluido
})

export const fetchHistory = ({
  projetoId,
  dataInicial,
  dataFinal,
  pageId = 1,
  pageSize = HISTORY_PAGE_SIZE,
  motivoconcluido = 'todos'
}) => {
  return async dispatch => {
    dispatch({ type: HISTORY_FETCH_REQUEST })
    dispatch(loading())

    try {
      const paramsListagem = {
        projetoId,
        de: dataInicial,
        ate: dataFinal,
        pageId,
        pageSize
      }

      const paramsResumo = {
        projetoId,
        de: dataInicial,
        ate: dataFinal
      }

      const [responseHistorico, responseResumo] = await Promise.all([
        apiPdca.get('/pdca/planos/historico', { params: paramsListagem }),
        apiPdca.get('/pdca/planos/historico/resumo', { params: paramsResumo })
      ])

      const dataHistorico = responseHistorico?.data || {}
      const dataResumo = responseResumo?.data || {}

      const itens = normalizarPlanos(dataHistorico?.itens)

      dispatch({
        type: HISTORY_FETCH_SUCCESS,
        payload: {
          itens,
          total: Number(dataHistorico?.totalItens || 0),
          totalItens: Number(dataHistorico?.totalItens || 0),
          totalPaginas: Number(dataHistorico?.totalPaginas || 0),
          pageId: Number(dataHistorico?.pageId || pageId || 1),
          pageSize: Number(dataHistorico?.pageSize || pageSize || HISTORY_PAGE_SIZE),
          resumo: dataResumo?.resumo
            ? {
                projetoId: dataResumo?.projetoId,
                de: dataResumo?.de,
                ate: dataResumo?.ate,
                resumo: dataResumo?.resumo
              }
            : null,
          filtros: {
            dataInicial,
            dataFinal,
            motivoconcluido: motivoconcluido || 'todos'
          }
        }
      })
    } catch (error) {
      dispatch({
        type: HISTORY_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar histórico.'
      })
    } finally {
      dispatch(loaded())
    }
  }
}